import { MutationTree } from "vuex";
import { TerratalkLiveMutations, TerratalkLiveMutationNames, S } from "./types";

const terratalkLiveMutations: MutationTree<S> & TerratalkLiveMutations = {
  [TerratalkLiveMutationNames.HIDE_SESSION_ENDED_MODAL](state) {
    state.modals.sessionEnded.open = false;
  },

  [TerratalkLiveMutationNames.HIDE_SESSION_STARTED_MODAL](state) {
    state.modals.sessionStarted.open = false;
  },

  [TerratalkLiveMutationNames.LIMITED_MODE_DETAILS](state, limitedModeDetails) {
    state.limitedModeDetails = limitedModeDetails;
  },

  [TerratalkLiveMutationNames.LIVE_STATE](state, liveState) {
    state.liveState = liveState;
  },

  [TerratalkLiveMutationNames.PREVIOUS_FETCHER_ALIAS](state, selectedAlias) {
    state.previousFetcherAlias = selectedAlias;
  },

  [TerratalkLiveMutationNames.SESSIONS](state, sessionsById) {
    state.sessions = sessionsById;
  },

  [TerratalkLiveMutationNames.SESSION_DETAILS](state, sessionDetails) {
    state.sessionDetails = sessionDetails;
  },

  [TerratalkLiveMutationNames.SHOW_SESSION_ENDED_MODAL](state) {
    state.modals.sessionEnded.open = true;
  },

  [TerratalkLiveMutationNames.SHOW_SESSION_STARTED_MODAL](state) {
    state.modals.sessionStarted.open = true;
  }
};

export { terratalkLiveMutations };
